import { FunctionComponent, useState } from "react";

interface PreviewAvatarProps {
	imageUrl?: string | null;
	initials: string;
	name: string;
}

export const PreviewAvatar: FunctionComponent<PreviewAvatarProps> = ({
	imageUrl,
	initials,
	name,
}) => {
	const [imageError, setImageError] = useState(false);

	if (imageUrl && !imageError) {
		return (
			<img
				alt={name}
				className="w-6 h-6 rounded-full object-cover"
				referrerPolicy="no-referrer"
				src={imageUrl}
				onError={() => setImageError(true)}
			/>
		);
	}

	return (
		<div className="flex items-center justify-center w-6 h-6 rounded-full bg-blue-action text-white text-xs font-medium shrink-0">
			{initials || "?"}
		</div>
	);
};
